import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { EllipsisOutlined } from "@ant-design/icons";
import { Button, Drawer, Dropdown, Form, Layout, MenuProps, message, Space, Spin, Tabs, TabsProps} from "antd";
import dayjs from "dayjs";
import { get, isEmpty, isNull } from "lodash";
import { FunctionComponent, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BrowsingResults from "../../../components/course-construction/assign-course-construction/browsing-results";
import ClassRegister from "../../../components/course-construction/content-course-construction/class-register";
import StatisticCourse from "../../../components/course-construction/content-course-construction/statistic-course";
import TabsSettingCommon from "../../../components/course-construction/content-course-construction/tabs-setting-common";
import CourseConstruct from "../../../components/course-construction/list-course-construction/course-constructor";
import CourseDetailView from "../../../components/course-construction/list-course-construction/course-constructor/CourseConstructView";
import SafeLink from "../../../components/link/SafeLink";
import BrowseCourseModal from "../../../components/modal/browse-course";
import PageHeader from "../../../components/page-header/PageHeader";
import { routesConfig } from "../../../config/routes";
import { useDirty } from "../../../contexts/DirtyProvider";
import useKeyword from "../../../hooks/useKeyword";
import { usePreventRouteChange } from "../../../hooks/usePreventRouteChange";
import { Permission } from "../../../layout/sidebar/permission.enum";
import {
  createSettingCourse,
  getAllStatusReviewCourse,
  getDataGeneral,
  getHistoryByCourseId,
  updateImageTeacher,
} from "../../../service/content-course/contenCourseApi";
import { browseSource, getCourseDetail, publishCourse, } from "../../../service/course-construct";
import { HelpService } from "../../../service/helper.service";
import { CourseConstructionStore, globalStore } from "../../../stores/stores";
import { ConstructCourseDetailType, Section, } from "../../../types/course-construction";
import { CheckRole, getPermissions } from "../../../utils/checkRole";
import PageBuilder from "../../page-builder/PageBuilder";
import { formatDateToIsoStringHHss } from "../../../utils/converDate";
import { getIdIndexDB } from "../../page-builder/grapesjs-service";
import { IBodyTemplates } from "../../../types/grapesjs";
import { saveTemplates } from "../../../service/page-builder/page-builder";
import ImportMoocsFile from "../../../components/import-mooc-file/ImportMoocsFile";
import { handleDownloadMoocsFile } from "../../../utils/exportMoocsFile";
import "./index.scss";
import { toBase64 } from "../../../utils/app";

const { Content } = Layout;
const imgPath = "/images/";

const ContentCourseDetail: FunctionComponent = () => {
  const { t } = useTranslation();
  const helpService = new HelpService();
  const { reload, setReload } = globalStore();
  const { setCourseData } = CourseConstructionStore()
  const { setDirty, isDirty } = useDirty();
  const { confirmNavigation } = usePreventRouteChange();
  const location = useLocation();
  const [detailData, setDetailData] = useState<ConstructCourseDetailType>({});
  const [sections, setSections] = useState<Section[]>([]);
  const [listPermission, setListPermission] = useState([]);
  const contentCourseTab = useKeyword("tab");

  const params = useParams();
  const navigate = useNavigate();
  const [isShowSubmitButton, setIsShowSubmitButton] = useState(true);
  const [dataConfig, setDataConfig] = useState(null);
  const [initialValues, setInitialValues] = useState({
    layoutName: "",
    assignersRequest: [],
    isHasCertification: false,
    isScheduleByTeacher: false,
    isCostFree: false,
    isDefault: false,
    courseFormatId: 0,
  });
  const [loading, setLoading] = useState(false);
  const [dataForm, setDataForm] = useState<any>({});
  const [form] = Form.useForm();
  const [isCertificate, setIsCertificate] = useState(false);
  const [displayRole, setDisplayRole] = useState(false);
  const [displayRoleSettingPage, setDisplayRoleSettingPage] = useState(false);
  const [displayConstructionPage, setDisplayConstructionPage] = useState(false);
  const [displayRegisterPage, setDisplayRegisterPage] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [certificateId, setCertificateId] = useState<number>(0);
  const [tab, setTab] = useState<string>(contentCourseTab || '2');
  const [dataAssinger, setDataAssinger] = useState([]);
  const [browseData, setBrowseData] = useState<ConstructCourseDetailType>();
  const [isOpenBrowseCourseModal, setIsOpenBrowseCourseModal] = useState<boolean>(false);
  const [clearForm, setClearForm] = useState<boolean>(false);
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [listImages, setListImages] = useState<any>([]);
  const [isReadyNextTab, setIsReadyNextTab] = useState<boolean>(false);
  const [tabForm, setTabForm] = useState<string>("1");
  const [detailDataBrowsingResults, setDetailDataBrowsingResults] = useState<any>();
  const [modePage, setModePage] = useState<string>('');
  const [openHistory, setOpenHistory] = useState(false);
  const [courseEditHistoryData, setCourseEditHistoryData] = useState<any>([]);
  const [historyLoading, setHistoryLoading] = useState<boolean>(false);
  const [isOpenImportMoocsFile, setIsOpenImportMoocsFile] = useState<boolean>(false);
  const [fileType, setFileType] = useState<string>('');

  useEffect(() => {
    getConfigCourseData();
    getRoles();
    getDetailDataBrowsingResults();
  }, [reload]);

  useEffect(() => {
    getDetailCourseData();
  }, [reload]);

  useEffect(() => {
    const roleIntroductionPage = [
      Permission.SetWebCourseActivityUpdate,
      Permission.SetCourseTagsUpdate,
      Permission.EditCourseTagsUpdate,
      Permission.PreviewCoursePresentationInterfaceUpdate,
      Permission.SelectPresentationScreenUpdate,
      Permission.SaveCoursePresentationInterfaceUpdate,
      Permission.CreateDraftPresentationInterfaceUpdate,
      Permission.OperatePresentationPageUpdate,
    ]

    const roleSettingPage = [
      Permission.SetWebCourseActivityView,
      Permission.SetWebCourseActivityUpdate,
      Permission.SetCourseTagsView,
      Permission.SetCourseTagsUpdate,
      Permission.EditCourseTagsView,
      Permission.EditCourseTagsUpdate,
      Permission.PreviewCoursePresentationInterfaceView,
      Permission.PreviewCoursePresentationInterfaceUpdate,
      Permission.SelectPresentationScreenView,
      Permission.SelectPresentationScreenUpdate,
      Permission.SaveCoursePresentationInterfaceView,
      Permission.SaveCoursePresentationInterfaceUpdate,
      Permission.CreateDraftPresentationInterfaceView,
      Permission.CreateDraftPresentationInterfaceUpdate,
    ]

    const roleConstructionPage = [
      Permission.CreateLectureView,
      Permission.CreateLectureUpdate,
      Permission.CreateChapterView,
      Permission.CreateChapterUpdate,
      Permission.CreateLearningMaterialView,
      Permission.CreateLearningMaterialUpdate,
      Permission.CreateAssignmentTestExamView,
      Permission.CreateAssignmentTestExamUpdate,
      Permission.CreateAssignmentTestExamQuestionView,
      Permission.CreateAssignmentTestExamQuestionUpdate,
      // Permission.CreateCourseSurveyPlanUpdate,
      // Permission.CreateCourseSurveyQuestionUpdate,
    ]

    const roleRegisterPage = [
      Permission.OperatePresentationPageUpdate,
    ]

    const checkRole = CheckRole(roleIntroductionPage, listPermission)
    const checkRoleSettingPage = CheckRole(roleSettingPage, listPermission)
    const checkRoleConstructionPage = CheckRole(roleConstructionPage, listPermission)
    const checkRoleRegisterPage = CheckRole(roleRegisterPage, listPermission)

    if (checkRole.includes(true)) {
      setDisplayRole(true)
    }
    if (checkRoleSettingPage.includes(true)) {
      setDisplayRoleSettingPage(true)
    }
    if (checkRoleConstructionPage.includes(true)) {
      setDisplayConstructionPage(true)
    }
    if (checkRoleRegisterPage.includes(true)) {
      setDisplayRegisterPage(true)
    }
  }, [listPermission, reload]);


  useEffect(() => {
    if (!isNull(dataConfig)) {
      fillDetailForm();
    }
  }, [dataConfig]);

  useEffect(() => {
    if (Object.keys(dataForm).length > 0) {
      submitData(dataForm, listImages);
    }
  }, [dataForm]);

  useEffect(() => {
    setModePage(location.state?.mode);
  }, [location]);

  useEffect(() => {
    if (modePage === 'share') {
      setTab('4');
      setTabForm('4');
    } else if (modePage === 'view') {
      // setTab('1');
    }
    setIsReadyNextTab(true);
    if (modePage === 'create') {
    } else if (modePage === 'edit') {
      setEdit(true);
    } else if (modePage === 'view') {
    }
  }, [location.pathname, modePage]);

  const handleChangeSection = (data: Section[]) => {

    setSections([...data]);
  };

  const getDetailCourseData = async () => {
    try {
      setLoading(true);
      const response = await getCourseDetail(params?.id);
      const { data } = response.data;
      setDetailData(data);
      handleChangeSection(data?.sections);
    } catch (error) {
      console.error(error);
    }
    finally {
      setLoading(false)

    }
  };

  const getConfigCourseData = async () => {
    setLoading(true);
    try {
      const response = await getDataGeneral(Number(params?.id))
      const { data, success } = response.data;
      if (success) {
        setLoading(false)
        setDataConfig(data);
        setCourseData(data)
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fillDetailForm = () => {
    form.setFieldsValue({
      url: !isNull(get(dataConfig, "url", "")) ? get(dataConfig, "url", "").slice(8) : "",
      layoutName: get(dataConfig, "layoutName"),
      enrollStatedDate: get(dataConfig, "enrollStatedDate"),
      startTime: get(dataConfig, "enrollStatedDate"),
      enrollClosedDate: get(dataConfig, "enrollClosedDate"),
      endTime: get(dataConfig, "enrollClosedDate"),
      isHasCertification: get(dataConfig, "isHasCertification"),
      scheduleCourse: get(dataConfig, "schedule"),
      courseFormatId: get(dataConfig, "courseFormatId"),
      preCourses: get(dataConfig, "preCourses"),
      preSkills: get(dataConfig, "preSkills"),
      assignersRequest: get(dataConfig, "assigner"),
    });

    // @ts-ignore
    setDataAssinger(...get(dataConfig, 'assigner', []).map((assigner: any) => assigner.assigned))
    if (get(dataConfig, "courseCertificationId")) {
      setCertificateId(get(dataConfig, "courseCertificationId", 0));
    }
  }

  // Get course edit history
  const getCourseEditHistory = async () => {
    setOpenHistory(true);
    setHistoryLoading(true);
    const dataReq = {
      courseId: params?.id
    }
    await getHistoryByCourseId(dataReq).then((res) => {
      if (res.status === 200) {
        setCourseEditHistoryData(res.data?.data?.data);
        setHistoryLoading(false);
      }
    }).catch((err) => {
      console.error(err);
    }).finally(() => setHistoryLoading(false));
  }

  // Onclose Drawer
  const onClose = () => {
    setOpenHistory(false);
  };

  const getRoles = async () => {
    const params = await getPermissions();
    const listPermissionConvert = JSON.parse(JSON.stringify(params))
    setListPermission(listPermissionConvert)
  }

  const onFinish = (name: string, { forms, values }: any) => {
    const baseUrl = "https://";
    const finalUrl = values.url.startsWith(baseUrl) ? values.url : `${baseUrl}${values.url}`;
    const valueDate = values.enrollClosedDate ? (
      !isNull(values.endTime) ? (
        dayjs(values.enrollClosedDate)
          .set('hour', dayjs(values.endTime).hour())
          .set('minute', dayjs(values.endTime).minute())
          .set('second', dayjs(values.endTime).second())
      ) : dayjs(values.enrollClosedDate)
    ) : null;

    setListImages({
      ...listImages,
      assignersRequest: values.assignerAvatar,
    });
    // @ts-ignore
    setDataForm({
      ...dataForm,
      courseId: Number(params.id),
      layoutName: values.layoutName,
      url: finalUrl,
      image: values.imageAvatar,
      isHasCertification: values.isHasCertification,
      preCourses: values.preCourses,
      preSkills: values.preSkills,
      enrollStatedDate: (dayjs(values.enrollStatedDate).set('hour', dayjs(values.startTime).hour())
        .set('minute', dayjs(values.startTime).minute())
        .set('second', dayjs(values.startTime).second())).toISOString(),
      enrollClosedDate: valueDate
      ,
    });
  };

  // @ts-ignore
  const submitData = async (dataReq: any, images: any) => {
    setLoading(true)
    try {
      if (
        images.assignersRequest &&
        Array.isArray(images.assignersRequest) &&
        images.assignersRequest.length > 0 && dataAssinger.length > 0
      ) {
        const dataImage = images.assignersRequest.map((item: any) => ({
          teacherId: item.id,
          imageTeacher: item.image ? item.image : null
        }))
        const dataImageReq = {
          courseId: Number(params?.id),
          courseTeacherUpdateRequest: dataImage
        }
        const res = await updateImageTeacher(dataImageReq)
        setDirty(false)
      }
      const response = await createSettingCourse(dataReq);
      setDirty(false)
      if (response.status === 200) {
        message.success(t("Cài đặt thông tin thành công", "Cài đặt thông tin thành công"));
        setLoading(false);
        setReload(!reload)
      }
    } catch (err) {
      console.error(err);
    }
  };
  const resetForm = () => {
    if (isEdit) {
      fillDetailForm()

    } else {
      setInitialValues({
        ...initialValues,
        layoutName: "",
        assignersRequest: [],
        isHasCertification: false,
        isScheduleByTeacher: false,
        isCostFree: false,
        isDefault: false,
        courseFormatId: 1,
      })
    }
  }

  const handleSendToCheck = () => {
    if (detailData.status === "3") {
      message.error(t("Khoá học đang trong quá trình chờ duyệt", "Khoá học đang trong quá trình chờ duyệt"));
    } else {
      setIsOpenBrowseCourseModal(true);
      setBrowseData(detailData);
    }
  };
  const getIdIndexDBAsync = (key: string): Promise<any> => {
    return new Promise((resolve) => {
      getIdIndexDB(key, (val: any) => resolve(val));
    });
  };

  const saveCurrentTemplateBeforePublish = async (courseId: number) => {
    try {
      const val = await getIdIndexDBAsync("courseSavedTemplete-" + courseId);
      if (!val) return;

      const gjsProject = localStorage.getItem('gjsProject');
      if (gjsProject) {
        val.gjsProject = JSON.parse(gjsProject);
      }

      const detailDataTemplates: IBodyTemplates = {
        template: toBase64(JSON.stringify(val)),
        templateStatusCode: "published",
        isTemplateSample: false,
      };

      await saveTemplates(String(courseId), detailDataTemplates);
    } catch (error) {
      console.error(t("Lỗi khi lưu template:", "Lỗi khi lưu template:"), error);
    }
  };

  const handleUpdateStatusPublish = async () => {
    try {
      const courseId = detailData?.id;
      await saveCurrentTemplateBeforePublish(Number(courseId));

      const data = {
        courseIds: [courseId],
      };
      await publishCourse(data);

      helpService.closeProcess();
      setReload(!reload);
      message.success(t("Khoá học đã xuất bản thành công", "Khoá học đã xuất bản thành công"));
    } catch (error) {
      console.error(error);
      helpService.errorMessage(t("Xuất bản thất bại. Vui lòng thử lại!", "Xuất bản thất bại. Vui lòng thử lại!"));
    }
  };

  const handlePublish = () => {
    helpService.loadingProcess();
    if (detailData.status === "13") {
      message.error(t("Khoá học đã xuất bản", "Khoá học đã xuất bản"));
    } else {
      handleUpdateStatusPublish();
    }
  };
  const saveBrowseCourse = async (approveUserId: number) => {
    const data = {
      approveUserId: approveUserId,
    };
    await browseSource(browseData?.id, data).then((res) => {
      if (res.status === 200) {
        message.success(t("Yêu cầu duyệt khoá học được gửi thành công", "Yêu cầu duyệt khoá học được gửi thành công"));
        setIsOpenBrowseCourseModal(false);
        setClearForm(true);
      }
    });
  };

  const confirmModal = () => {
    message.success(t("Phân công khoá học thành công", "Phân công khoá học thành công"));
    setIsOpened(!isOpened);
  };

  const getDetailDataBrowsingResults = async () => {
    await getAllStatusReviewCourse(params?.id).then(res => {
      setDetailDataBrowsingResults(res.data.data)
    });
  }

  const tabItems: TabsProps["items"] = [
    ...(displayRole ? [{
      disabled: !isReadyNextTab,
      key: '1',
      label: t('Trang giới thiệu', 'Trang giới thiệu'),
      children: (
        <PageBuilder
          planInfo={location.state}
          detailData={detailData}
          setIsReadyNextTab={(val) => {
            setIsReadyNextTab(val)
          }}
          tab={tab}
          mode={modePage}
        />
      ),
    },] : []),
    ...(displayConstructionPage ? [{
      disabled: !isReadyNextTab,
      key: '2',
      label: t('Cấu trúc khóa học', 'Cấu trúc khóa học'),
      children:
        // change children here
        location.state?.mode !== 'view' ? (
          <div className='wrapper-course-construct'>
            <section className='detail-account'>
              <div className='form-detail'>
                <CourseConstruct
                  dataConfig={dataConfig}
                  sections={sections}
                  detailData={detailData}
                  handleGetDetail={getDetailCourseData}
                  setSections={handleChangeSection}
                  paramId={params.id}
                />
              </div>
            </section>
          </div>
        ) : (
          <div className='detail-course-construction'>
            <CourseDetailView detailData={detailData} />
          </div>
        ),
    },] : []),

    ...(displayRegisterPage && get(dataConfig, 'isScheduleByTeacher') ? [{
      key: '3',
      disabled: !isReadyNextTab,
      label: (<span>{t('Lớp ghi danh', 'Lớp ghi danh')}</span>),
      destroyInactiveTabPane: true,
      children: (
        <ClassRegister paramId={params.id} />
      ),
    }] : []),

    ...(displayRoleSettingPage ? [{
      disabled: !isReadyNextTab,
      key: '4',
      // icon: <LockOutlined />,
      label: t('Cài đặt', 'Cài đặt'),
      children: (
        <TabsSettingCommon
          form={form}
          initialValues={initialValues}
          isCertificate={isCertificate}
          isDirty={isDirty}
          tabForm={tabForm}
          setTabForm={setTabForm}
          setDirty={setDirty}
          certificateId={certificateId}
          setCertificateId={setCertificateId}
          setIsCertificate={setIsCertificate}
          resetForm={resetForm}
          onFinish={onFinish}
          detailData={dataConfig}
          courseStatus={location.state?.record?.status}
          courseDetail={location.state?.record}
          certificateDetails={detailData}
        />
      ),
    }] : []),
    {
      disabled: !isReadyNextTab,
      key: '5',
      label: t('Kết quả duyệt', 'Kết quả duyệt'),
      children: (
        <div className='wrapper-course-construct course-browse'>
          <section className='detail-account course-browse'>
            <div className='form-detail'>
              <BrowsingResults planInfo={location.state} detailData={detailDataBrowsingResults} />
            </div>
          </section>
        </div>
      ),
    },
    {
      disabled: !isReadyNextTab,
      key: '6',
      label: t('Thảo luận', 'Thảo luận'),
      children: <StatisticCourse />,
    },
  ];

  const listBreadcrumb = [
    {
      title: (<span>{t('Xây dựng khóa học', 'Xây dựng khóa học')}</span>),
    },
    {
      title: (
        <SafeLink to={`/${routesConfig.courseConstruction}/${routesConfig.contentConstruction}`}>
          <span>{t('Xây dựng nội dung', 'Xây dựng nội dung')}</span>
        </SafeLink>
      ),
    },
    {
      title: (
        <span style={{
        }}
        >{detailData?.name || ""}</span>
      ),
    },
  ];


  const handleChange = (value: string) => {
    if (isReadyNextTab) {
      confirmNavigation({ link: "" }, false, () => {
        setTab(value);
        setIsShowSubmitButton(true);
      });
    }
  };

  const handleOpenNewPageReview = () => {
    window.open(
      `/${routesConfig.courseConstruction}/${routesConfig.contentConstruction
      }/${routesConfig.coursePreview}/${detailData.id}${tab === "2" ? "?view=structureCourse" : ""
      }`,
      "_blank"
    );
  };

  const options1: MenuProps["items"] = [
    {
      key: "0",
      label: t("Cấu trúc khoá học", "Cấu trúc khoá học"),
      // icon: <BookOutlined />,
    },
    {
      key: "1",
      label: t("Danh sách nội dung", "Danh sách nội dung"),
      // icon: <EditOutlined />,
    },
    {
      key: "2",
      label: t("Danh sách tài liệu tham khảo", "Danh sách tài liệu tham khảo"),
      // icon: <CopyOutlined />,
    },
    {
      key: "3",
      label: t("Lịch sử chỉnh sửa", "Lịch sử chỉnh sửa"),
    },
    {
      key: "4",
      label: t("Tải lên chương", "Tải lên chương"),
    },
    {
      key: "5",
      label: t("Tải lên khóa học", "Tải lên khóa học"),
    },
    {
      key: "6",
      label: t("Tải xuống khóa học", "Tải xuống khóa học"),
    },
  ];

  useEffect(() => {
    navigate(`${location.pathname}?tab=${tab}`);
  }, [tab])

  return (
    <>
      <Content>
        <PageHeader
          title={
            `${location.state?.mode === "view"
              ? t("Xem chi tiết khóa học", "Xem chi tiết khóa học")
              : location.state?.mode === "edit"
                ? t("Sửa khóa học", "Sửa khóa học")
                : t("Thêm mới khóa học", "Thêm mới khóa học")
            } ${detailData?.name}` || ""
          }
          listBreadcrumb={listBreadcrumb}
          arrowLeft={imgPath + "arrowLeft.svg"}
          positionItem="column"
          breadcrumb={true}
          goBackPath={`/${routesConfig.courseConstruction}/${routesConfig.contentConstruction}`}
          headerGroupButton={isShowSubmitButton}
          childrenGroupButton={
            isShowSubmitButton && (
              <div className="button-container">
                <Button onClick={() => handleOpenNewPageReview()}>{t("Xem trước", "Xem trước")}</Button>
                {/* <Button onClick={() => handleSendToCheck()}>{t("Yêu cầu duyệt", "Yêu cầu duyệt")}</Button> */}
                <Button
                  onClick={() => handlePublish()}
                  className="button-publish"
                >{t("Xuất bản", "Xuất bản")}</Button>
                <Space>
                  <Dropdown
                    menu={{
                      items: options1,
                      onClick: ({ key }) => {
                        if (key === "1") {
                          confirmNavigation({ link: "" }, false, () => {
                            navigate(
                              `/${routesConfig.courseConstruction}/${routesConfig.contentConstruction}/${routesConfig.contentListCourse}/${params?.id}`,
                              {
                                state: {
                                  courseName: detailData?.name ?? "",
                                  modeTab: "1",
                                  modeback: "backState",
                                  mode: "edit",
                                  backLink: `/${routesConfig.courseConstruction}/${routesConfig.contentConstruction}/${routesConfig.contentCourseDetail}/${params?.id}`,
                                  tab: location.state.tab,
                                },
                              }
                            );
                          });
                        }

                        if (key === "2") {
                          confirmNavigation({ link: "" }, false, () => {
                            navigate(
                              `/${routesConfig.courseConstruction}/${routesConfig.contentConstruction}/${routesConfig.contentListCourse}/${params?.id}`,
                              {
                                state: {
                                  courseName: detailData?.name ?? "",
                                  mode: "view",
                                  modeTab: "4",
                                  modeback: "backState",
                                  backLink: `/${routesConfig.courseConstruction}/${routesConfig.contentConstruction}/${routesConfig.contentCourseDetail}/${params?.id}`,
                                  tab: location.state.tab,
                                },
                              }
                            );
                          });
                        }
                        if (key === "3") {
                          getCourseEditHistory();
                        }
                        if (key === "4") {
                          setFileType("section");
                          setIsOpenImportMoocsFile(true);
                        }
                        if (key === "5") {
                          setFileType("course");
                          setIsOpenImportMoocsFile(true);
                        }
                        if (key === "6") {
                          handleDownloadMoocsFile(Number(params?.id), "course", detailData.name);
                        }
                      },
                    }}
                    placement="bottomRight"
                  >
                    <Button>
                      <EllipsisOutlined />
                    </Button>
                  </Dropdown>
                </Space>
              </div>
            )
          }
        />
        <div className="tabs-heading">
          <Tabs
            // defaultActiveKey="1"
            activeKey={tab}
            onChange={handleChange}
            items={tabItems}
            destroyInactiveTabPane={true}
          // tabBarExtraContent={rightContent()}
          />
        </div>
        <Form.Provider
          onFormFinish={(name, { values, forms }) => {
            if (name === "create-browse-course-modal") {
              saveBrowseCourse(values.lecturerName);
            }
          }}
        >
          <BrowseCourseModal
            clearForm={clearForm}
            title={`${t("Gửi duyệt khoá học", "Gửi duyệt khoá học")} ${browseData?.name}`}
            open={isOpenBrowseCourseModal}
            handleOk={confirmModal}
            handleCancel={() => {
              setIsOpenBrowseCourseModal(!isOpenBrowseCourseModal);
            }}
            browseData={browseData}
          />

          {/* <SyncCourseModal
            clearForm={clearForm}
            setSyncCourseCheckbox={setSyncCourseCheckbox}
            title={`${t("Đồng bộ khoá học", "Đồng bộ khoá học")} ${browseData?.name}`}
            open={isOpenSyncCourseModal}
            handleOk={confirmModal}
            handleCancel={() => {
              setIsOpenSyncCourseModal(!isOpenSyncCourseModal);
            }}
            browseData={browseData}
          /> */}
        </Form.Provider>
        <Spin spinning={loading} fullscreen />
      </Content>
      <Drawer
        title={t("Lịch sử chỉnh sửa", "Lịch sử chỉnh sửa")}
        open={openHistory}
        onClose={onClose}
        width={450}
        className="attendance-history-drawer"
      >
        <div className="attendance-history-drawer__content">
          {historyLoading ?
            <Spin spinning={historyLoading} />
            :
            courseEditHistoryData.length > 0 &&
            courseEditHistoryData.map((item: any, index: number) => {
              return (
                <div className="flex">
                  <span className="mr-3">{index + 1}</span>
                  <span>
                    {item.title} {t("lúc", "lúc")} {formatDateToIsoStringHHss(item.createdDate)} {t("bởi", "bởi")}{" "}
                    {item.userprofileName}
                  </span>
                </div>
              );
            })}
        </div>
      </Drawer>
      <ImportMoocsFile 
        id={params?.id}
        parentId={params?.id}
        type={fileType}
        isOpenImportMoocsFile={isOpenImportMoocsFile}
        setIsOpenImportMoocsFile={setIsOpenImportMoocsFile}
      />
    </>
  );
};

export default ContentCourseDetail;
